import { useRef, useState, useEffect } from 'react';
import { TALENT_ID, TALENT_ARR } from '../../data/define';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { useTranslation } from '../../hook/useTranslation';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const TextList = [
  {
    id: TALENT_ID.LANGUAGE,
    main: '언어지능에 대한 영상 정보가 필요해요!',
    sub: '대화를 하거나 질문에 답하는 영상을 올려주세요',
  },
  {
    id: TALENT_ID.MUSIC,
    main: '음악지능에 대한 영상 정보가 필요해요!',
    sub: '노래를 부르거나 음악을 듣는 영상을 올려주세요',
  },
  {
    id: TALENT_ID.PHYSICAL,
    main: '신체운동지능에 대한 영상 정보가 필요해요!',
    sub: '몸이나 손을 움직이는 활동 영상을 올려주세요',
  },
  {
    id: TALENT_ID.MATH,
    main: '논리수학지능에 대한 영상 정보가 필요해요!',
    sub: '정보를 계산하고 암기하는 영상을 올려주세요',
  },
  {
    id: TALENT_ID.SPACE,
    main: '공간지능에 대한 영상 정보가 필요해요!',
    sub: '퍼즐, 블록 등 물건을 배치하는 영상을 올려주세요',
  },
  {
    id: TALENT_ID.RELATIONSHIP,
    main: '대인관계지능에 대한 영상 정보가 필요해요!',
    sub: '다른 사람과 교류 및 활동하는 영상을 올려주세요',
  },
  {
    id: TALENT_ID.REFLECTION,
    main: '자기성찰지능에 대한 영상 정보가 필요해요!',
    sub: '과제를 하거나 감정이 보이는 영상을 올려주세요',
  },
  {
    id: TALENT_ID.NATURE,
    main: '자연친화지능에 대한 영상 정보가 필요해요!',
    sub: '동·식물 및 자연과 환경에 대한 영상을 올려주세요',
  },
];

function NeededIntelligenceCarousel({ neededIntelligenceIds = [], setIsOpenToggleBtn }) {
  const swiperRef = useRef(null);
  const [filteredTexts, setFilteredTexts] = useState([]);
  const { t } = useTranslation();

  // 필터링된 텍스트 목록 생성
  useEffect(() => {
    const filtered = TextList.filter((item) => neededIntelligenceIds.includes(item.id));
    setFilteredTexts(filtered);
  }, [neededIntelligenceIds]);

  if (filteredTexts.length === 0) {
    return null;
  }

  const getTranslatedText = (item) => {
    const talentKey = TALENT_ARR.find((tlt) => tlt.id === item.id)?.key;
    return {
      main: talentKey ? t(`home.guide.inProgress.${talentKey}.title`) : item.main,
      sub: talentKey ? t(`home.guide.inProgress.${talentKey}.desc`) : item.sub,
    };
  };

  return (
    <div
      className="w-full"
      style={{ marginLeft: '-2px', marginRight: '-20px', width: 'calc(100% + 40px)' }}
    >
      {filteredTexts.length >= 2 ? (
        <Swiper
          ref={swiperRef}
          modules={[Autoplay]}
          className="mySwiper"
          spaceBetween={10}
          slidesPerView="auto"
          loop={filteredTexts && filteredTexts?.length >= 2}
          // autoplay={{
          //   delay: 4000,
          //   disableOnInteraction: false,
          // }}
          centeredSlides={false}
          slidesOffsetBefore={4}
          slidesOffsetAfter={40}
        >
          {filteredTexts.length >= 1 &&
            filteredTexts.map((text, idx) => {
              const translated = getTranslatedText(text);
              return (
                <SwiperSlide
                  key={`${text.id}-${idx}`}
                  className="p-[20px] my-1 rounded-[16px] bg-[#fff] border-none"
                  style={{
                    boxShadow: '0px 0px 10px 0px rgba(29, 32, 32, 0.1)',
                    width: 'calc(100vw - 85px)',
                    maxWidth: 'calc(100vw - 85px)',
                  }}
                >
                  <button
                    type="button"
                    className="w-full"
                    onClick={() => {
                      (setIsOpenToggleBtn as any)(true);
                    }}
                  >
                    <div className="w-full flex items-center justify-between mb-[8px]">
                      <div className="text-[#1C1C1C] text-[14px] font-[700] text-left">
                        {translated.main}
                      </div>
                    </div>
                    <div className="text-[#1C1C1C] text-[14px] font-[400] text-left">
                      <span className="font-[700] text-[#5EBEBB]">{t('home.tip')}</span>
                      &nbsp;
                      <span>{translated.sub}</span>
                    </div>
                  </button>
                </SwiperSlide>
              );
            })}
        </Swiper>
      ) : (
        <button
          type="button"
          className="p-[20px] rounded-[16px] bg-[#fff] w-full mb-[16px]"
          onClick={() => {
            (setIsOpenToggleBtn as any)(true);
          }}
          style={{ boxShadow: '0px 0px 10px 0px rgba(29, 32, 32, 0.07)' }}
        >
          <div className="w-full flex items-center justify-between mb-[8px]">
            <div className="text-[#1C1C1C] text-[14px] font-[700] text-left">
              {getTranslatedText(filteredTexts[0]).main}
            </div>
          </div>
          <div className="text-[#1C1C1C] text-[14px] font-[400] text-left">
            <span className="font-[700] text-[#5EBEBB]">{t('home.tip')}</span>
            &nbsp;
            <span>{getTranslatedText(filteredTexts[0]).sub}</span>
          </div>
        </button>
      )}
    </div>
  );
}

export default NeededIntelligenceCarousel;

